import { Box, Typography } from "@mui/material";
import Style from '../../SipocDiagram.module.css';

interface CriticalMatrixProps {
  criticalMatrices: any[];
}

// Helper function to format the impact value
const formatImpactValue = (value: number | string) => {
  if (value === null || value === undefined || value === '') return '-';

  const numValue = typeof value === 'string' ? parseInt(value, 10) : value;

  if (isNaN(numValue)) return '-';

  switch (numValue) {
    case 1:
      return 'Low Impact (1)';
    case 3:
      return 'Medium Impact (3)';
    case 5:
      return 'High Impact (5)';
    default:
      return `${numValue}`;
  }
};

const CriticalMatrix: React.FC<CriticalMatrixProps> = ({ criticalMatrices = [] }) => {
  return (
    <>
      <Typography variant="h6">Critical Matrix</Typography>

      <Box>
        <Box display="flex" className={Style.spoicdataheader} sx={{ fontWeight: '400', mb: 2, gap: '15px' }}>
          <Box flex={2}>
            <Typography variant="h5" className={Style.spoicdatatitle}>SERVICES / OUTPUTS / DELIVERABLES</Typography>
          </Box>
          <Box flex={1}>
            <Typography variant="h5" className={Style.spoicdatatitle}>Reputational/ External impact on [customers/vendors/employee relations/shareholders/auditors]</Typography>
          </Box>
          <Box flex={1}>
            <Typography variant="h5" className={Style.spoicdatatitle}>Monthly Financial Impact – Transactional Value (e.g., Total overdue/orders/receivables/Overheads or MJEs) divided by P&L of the country (e.g. Net Revenue /EBITDA /Cashflow / ZBB of the country) </Typography>
          </Box>
          <Box flex={1}>
            <Typography variant="h5" className={Style.spoicdatatitle}>Compliance or External regulatory affairs impact</Typography>
          </Box>
          <Box flex={1}>
            <Typography variant="h5" className={Style.spoicdatatitle}>Time to deliver the service</Typography>
          </Box>
          <Box flex={1}>
            <Typography variant="h5" className={Style.spoicdatatitle}>Sum</Typography>
          </Box>
          <Box flex={1}>
            <Typography variant="h5" className={Style.spoicdatatitle}>Critical</Typography>
          </Box>
        </Box>

        <Box sx={{ maxHeight: '200px', overflowY: 'auto', width: '104%' }}>
          {criticalMatrices?.map((matrix: any, index: number) => (
            <Box
              key={`critical-matrix-${index}`}
              display="flex"
              className={Style.spoicdata}
              sx={{ mb: 2 }}
            >
              <Box flex={2}>
                {matrix.output?.split('|').map((output: string, subIndex: number) => (
                  <Typography key={subIndex}>
                    {index + 1}. {output.trim() || '-'}
                  </Typography>
                ))}
              </Box>
              <Box flex={1}>
                <Typography className={Style.spoicdatatitle}>
                  {formatImpactValue(matrix.reputational_external_impact_on)}
                </Typography>
              </Box>
              <Box flex={1}>
                <Typography className={Style.spoicdatatitle}>
                  {formatImpactValue(matrix.monthly_financial_impact)}
                </Typography>
              </Box>
              <Box flex={1}>
                <Typography className={Style.spoicdatatitle}>
                  {formatImpactValue(matrix.compliance_or_external_regulatory_affairs_impact)}
                </Typography>
              </Box>
              <Box flex={1}>
                <Typography className={Style.spoicdatatitle}>
                  {formatImpactValue(matrix.time_to_deliver_the_service)}
                </Typography>
              </Box>
              <Box flex={1}>
                <Typography className={Style.spoicdatatitle}>{matrix.sum || '-'}</Typography>
              </Box>
              <Box flex={1}>
                <Typography className={Style.spoicdatatitle}>{matrix.critical || '-'}</Typography>
              </Box>
            </Box>
          ))}
        </Box>
      </Box>
    </>
  );
};

export default CriticalMatrix;